import { PureComponent } from 'react'
import XAxisTick from '../../../../../../Common/NewDashboard/Chart/XAxisTick/XAxisTick'
import {
  getMomentDateTimeFromApiData
} from '../../../../../../../lib/MomentHelper'

class CustomizeXAxisTick extends PureComponent {
  render () {
    const { x, y, payload, format } = this.props
    const tickDate = getMomentDateTimeFromApiData(payload.value).format(format)

    return (
      <XAxisTick svgProps={{ x, y }}>
        <>
          <tspan
            x={0}
            dy={12}
          >
            {tickDate}
          </tspan>
        </>
      </XAxisTick>
    )
  }
}

export default CustomizeXAxisTick
